import React from 'react';
import CardMedia from '@mui/material/CardMedia';

import pdfImg from 'assets/images/PdfFile.png';
import './DisplayPdfDocumentThumbnail.scss';

const pdfCardPreview = {
  width: '70%',
  mx: 'auto',
  objectFit: 'contain',
  position: 'relative',
};

interface DisplayPdfDocumentThumbnailProps {
  thumbnailBuffer?: ArrayBuffer;
}

const DisplayPdfDocumentThumbnail: React.FC<DisplayPdfDocumentThumbnailProps> = ({ thumbnailBuffer }) => {
  if (!thumbnailBuffer) {
    return <CardMedia component='img' image={pdfImg} sx={pdfCardPreview} alt='pdf-thumbnial' />;
  }

  const blob = new Blob([thumbnailBuffer]);
  const url = URL.createObjectURL(blob);

  return <CardMedia component='img' image={url} sx={pdfCardPreview} alt='pdf-thumbnial' />;
};

export default DisplayPdfDocumentThumbnail;
